export default __webpack_public_path__ + "assembly15d020f.png";